/*
 * @Descripttion:
 * @Author: 01387189
 * @Date: 2021-07-14 14:30:09
 * @LastEditors: 01387189
 * @LastEditTime: 2021-07-15 16:13:41
 */
// 交易记录模块
const transaction = [
  {
    path: "/transaction/myorder",
    name: "myorder",
    meta: {
      title: "订单列表-顺丰科技数字商店",
    },
    component: () =>
      import(/* webpackChunkName:'home' */ "@/pages/transaction/Myorder"),
  },
  {
    path: "/transaction/orderdetail",
    name: "orderdetail",
    meta: {
      title: "订单详情-顺丰科技数字商店",
    },
    component: () =>
      import(/* webpackChunkName:'home' */ "@/pages/transaction/OrderDetail"),
  },
];

export default transaction;
